import React, { Component } from 'react'
import { EditorFactory } from '@/components/commons/editor/EditorFactory'
import { withBaseElement } from '@/hocs/withBasicElement'
import { getElements, getActiveElement, getForceUpdate } from '@/store/getters'
import { connect } from 'react-redux'

class Elements extends Component {

  shouldComponentUpdate ( newProps ) {
    if( newProps.forceUpdate !== this.props.forceUpdate ){
      return true
    }
    if( newProps.elements.length !== this.props.elements.length ){
      return true
    }
    for ( let index in newProps.elements ) { 
      if( newProps.elements[index].id_page !== this.props.elements[index].id_page )
        return true
    }
    return false
  }

  /**
   * Return the basic element
   * @param {Oject} item 
   * @param {Function} setActiveComponent 
   * @param {Function} onRemoveElement 
   */
  getElement = ( item ) => {
    const { content } = item
    const Component = withBaseElement(
      EditorFactory( content.elementType ),
      {
        page_id: +item.id_page,
        id: +item.id,
        content: content
      }
    )
    return <Component key={item.id} />
  }

  render () {
    return (
      <React.Fragment>
        {this.props.elements.map( item => {
          return this.getElement( item )
        } )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const elements = getElements( state )
  const actualElement = getActiveElement( state )
  const forceUpdate = getForceUpdate( state )
  return {
    elements,
    actualElement,
    forceUpdate
  }
}
export default connect(
  mapStateToProps
) ( Elements )


// WEBPACK FOOTER //
// ./src/pages/Editor/components/Pages/Elements.js